export const ADDRESSES = {
  supportEmail: 'info@balloonapp.de'
};
